/* =========================================================
   VALARNI – Wishlist (site-wide)
   - Same storage as the existing hearts: localStorage "vl_wishlist"
     (array of product handles, oldest first). No account needed.
   - Handles every heart button [data-vlc-wish] / [data-vl-wish] on the
     site that is not already handled by its own section script.
   - Adds a heart on product pages.
   - Sends logged-out visitors to the account page with return_to.
   ========================================================= */
(function () {
  'use strict';
  if (window.VLWishlist) return;

  var KEY = 'vl_wishlist';
  function L(k, d) { return (window.VL_T && window.VL_T[k]) || d; }
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.8-4.6-7.8-10.3A4.5 4.5 0 0 1 12 7.2a4.5 4.5 0 0 1 7.8 2.8c0 5.7-7.8 10.3-7.8 10.3z"/></svg>';

  function clean(list) {
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (h) {
      if (typeof h === 'string' && h && h.length < 256 && /^[^\s<>"'\/]+$/.test(h) && out.indexOf(h) === -1) out.push(h);
    });
    return out;
  }
  function get() {
    try { return clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch (e) { return []; }
  }
  function set(list) {
    try { localStorage.setItem(KEY, JSON.stringify(clean(list))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:update'));
  }
  function has(handle) { return get().indexOf(handle) > -1; }
  function toggle(handle, force) {
    var list = get(), i = list.indexOf(handle);
    var add = typeof force === 'boolean' ? force : i === -1;
    if (add && i === -1) list.push(handle);
    if (!add && i > -1) list.splice(i, 1);
    set(list);
    document.dispatchEvent(new CustomEvent('vlc:wishlist', { detail: { handle: handle, added: add } }));
    return add;
  }

  function sync() {
    var list = get();
    document.querySelectorAll('[data-vlc-wish],[data-vl-wish]').forEach(function (b) {
      var h = b.getAttribute('data-vlc-wish') || b.getAttribute('data-vl-wish');
      var on = list.indexOf(h) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? L('js.wish_remove', 'Remove from wishlist') : L('js.wish_add', 'Add to wishlist'));
    });
  }

  /* One click handler for every heart not already handled by its own section */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var b = e.target.closest('[data-vlc-wish],[data-vl-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-vlc-wish') || b.getAttribute('data-vl-wish');
    toggle(h);
    sync();
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
  });
  document.addEventListener('wishlist:update', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); document.dispatchEvent(new CustomEvent('wishlist:external')); } });

  /* Heart on the product page (over the main media gallery) */
  function productHeart() {
    var handle = window.VL_PRODUCT_HANDLE;
    if (!handle) return;
    var media = document.querySelector('#MainContent .product-information__media');
    if (!media || media.querySelector('.vl-pheart')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vl-pheart';
    btn.setAttribute('data-vl-wish', handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', L('js.wish_add', 'Add to wishlist'));
    btn.innerHTML = HEART;
    media.classList.add('vl-pheart-host');
    media.appendChild(btn);
  }

  /* Account links: logged-out visitors go to our account page, then come back here */
  function accountLinks() {
    if (window.VL_CUSTOMER) return;
    var here = location.pathname + location.search;
    if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/(pages\/account|account|customer_authentication)/i.test(location.pathname)) return;
    var target = ROOT + 'pages/account?return_to=' + encodeURIComponent(here);
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.hasAttribute('data-vl-account-link')) { a.setAttribute('href', target); return; }
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      /* the theme's "Sign in / Account" links (/account, /account/login, with or without a locale prefix) */
      if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/account(\/login)?\/?$/i.test(u.pathname)) a.setAttribute('href', target);
    });
  }

  function init() { productHeart(); accountLinks(); sync(); }

  window.VLWishlist = { get: get, set: set, has: has, toggle: toggle, sync: sync, KEY: KEY };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
